// 统一的预付款计算工具
// 默认：按金额的一定比例计算预付款，并对结果做“最高封顶 10 万”的限制

export const PREPAYMENT_CAP = 100000

/**
 * 计算预付款（带封顶）
 * @param {number} baseAmount 基础金额（如订单总金额）
 * @param {number} ratio 比例（例如 0.5 表示 50%）
 * @param {number} cap 封顶金额，默认 100000
 * @returns {number} 预付款金额（已四舍五入到 2 位小数）
 */
export function calcPrepaymentWithCap(baseAmount, ratio = 0.5, cap = PREPAYMENT_CAP) {
  const amountNum = Number(baseAmount) || 0
  const ratioNum = Number(ratio) || 0
  const capNum = Number(cap) || 0

  if (amountNum <= 0 || ratioNum <= 0 || capNum <= 0) return 0

  // 先按比例算出预付款，再做封顶，最后四舍五入到两位小数
  const raw = amountNum * ratioNum
  const limited = Math.min(raw, capNum)
  return Number(limited.toFixed(2))
}


